/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import Tabla from '@infotrack/presentacion-componentes/tabla';

import { ITablaUnidadesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaUnidades: React.FunctionComponent<ITablaUnidadesVistaProps & InjectedIntlProps> = ({
    unidadess,
    cargarUnidades,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={unidadess}
            actions={acciones(manejarFormulario, cargarUnidades, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaUnidades);
